import { createAction, props } from '@ngrx/store';
import { FullPatientProfile } from '../../models/full-patient-profile';
import { PatientProfile } from '../../models/patient-profile';

export const getProfile = createAction('[Profile] Get Profile');

export const getProfileSuccess = createAction(
  '[Profile] Get Profile Success',
  props<{ profile: PatientProfile; source?: 'default' | 'print' }>()
);

export const getProfileFailure = createAction('[Profile] Get Profile Failure', props<{ error: unknown }>());

export const saveProfile = createAction('[Profile] Save Profile', props<{ profile: PatientProfile }>());

export const saveProfileSuccess = createAction('[Profile] Save Profile Success', props<{ profile: PatientProfile }>());

export const saveProfileFailure = createAction('[Profile] Save Profile Failure', props<{ error: unknown }>());

export const getFullProfile = createAction('[Profile] Get Full Profile');

export const getFullProfileSuccess = createAction(
  '[Profile] Get Full Profile Success',
  props<{ fullProfile: FullPatientProfile }>()
);

export const getFullProfileFailure = createAction('[Profile] Get Full Profile Failure', props<{ error: unknown }>());
